import { Center, Flex, FlexProps, Image } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaPageTitle } from "../../lib/components/rana-page-title";

export interface DropsWiseAuthorisationBackgroundProps {
  pageSubTitle: ReactNode;
  logoSrc: string;
  backgroundSrc: string;
}

export function DropsWiseAuthorisationBackground({
  pageSubTitle,
  logoSrc,
  backgroundSrc,
  children,
  ...rest
}: DropsWiseAuthorisationBackgroundProps & FlexProps) {
  return (
    <Flex
      position="relative"
      w="full"
      minH="vh"
      flexDir="column"
      alignItems="center"
      p={6}
      bgGradient="linear(to-tr, white, brand.keep_analytic)"
      color="brand.deep_sea"
      fontWeight={300}
      {...rest}
    >
      <Image
        src={backgroundSrc}
        alt="DropsWise"
        position="absolute"
        top={0}
        right={0}
        w="1/2"
        h="full"
        objectFit="cover"
        pointerEvents="none"
      />
      <RanaPageTitle subTitle={pageSubTitle} />
      <Center flex={1} flexDir="column" position="relative">
        <Image src={logoSrc} alt="DropsWise" w="2xl" maxW="full" mb={8} />
        {children}
      </Center>
    </Flex>
  );
}
